import createAction from "redux-actions/es/createAction";
import { toastr } from "react-redux-toastr";
// import { selectDefaultProject as api } from "../api/apiUrl";
import { selectDefaultProject as api } from "../common/menu/api/index";
import { updateProject as updateApi } from "../common/menu/api/index";
import { getPiechartBulk } from "../components/dashboard/actions/index";

import { store } from "../index";

export const auth = createAction("AUTHENTICATE");
export const kickOut = createAction("KICK_OUT");
export const refreshToken = createAction("REFRESH_TOKEN");

export const loadInitClientData = createAction("LOAD_INIT_CLIENT_DATA_START");
export const loadInitClientDataSuccess = createAction(
  "LOAD_INIT_CLIENT_DATA_SUCCESS"
);
export const loadInitClientDataFail = createAction(
  "LOAD_INIT_CLIENT_DATA_FAIL"
);

export const getuserInfomation = () => {
  return async (dispatch) => {
    return await api()
      .then((res) => {
        if (res.status === 200) {
          let d = res.data;
          let payload = { accounts: d };
          let bulk = res.data.projects.map((item) => {
            let name = item.split("-");
            if (name[0] && name[1]) {
              return {
                collectionName: name[0],
                subCategory: name[1],
              };
            }
          });
          dispatch(loadInitClientDataSuccess(payload));
          dispatch(getPiechartBulk(bulk));
        
        }
      })
      .catch((err) => {
        dispatch(loadInitClientDataFail(err));
      });
  };
};

export const updateInfomation = (data) => {
  return async (dispatch) => {
    return await updateApi(data)
      .then((res) => {
        if (res.status === 200) {
          let data = res.data;
          toastr.success("Project Information", data);
          dispatch(getuserInfomation());
        }
      })
      .catch((err) => {
        dispatch(loadInitClientDataFail(err));
      });
  };
};
